'use client';

import React from 'react';

import { FacebookIconV2 } from '@depop/web-ui-kit/Icons/FacebookIconV2';
import { LinkIcon } from '@depop/web-ui-kit/Icons/LinkIcon';
import { LinkedInIcon } from '@depop/web-ui-kit/Icons/LinkedInIcon';
import { XIcon } from '@depop/web-ui-kit/Icons/XIcon';
import { useParams } from 'next/navigation';
import { useTranslations } from 'next-intl';

import styles from './styles.module.css';

import { useBlogTracking } from '@/modules/blog/hooks/useBlogTracking';
import { isServerCheck } from '@/modules/env/isServerCheck';
import { getCurrentHref } from '@/modules/routing/helpers';
import { useClipboard } from '@/utils/useClipboard';

export function ShareMedia() {
  const t = useTranslations('blog');
  const { sendBlogInteractionActionEvent } = useBlogTracking();
  const { slug } = useParams<{ slug: string }>();
  const { copyToClipboard } = useClipboard();
  const shareUrl = isServerCheck() ? '' : getCurrentHref();
  const popupOptions =
    'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=253,width=600';

  function shareX() {
    const shareTwitterUrl = `https://x.com/intent/tweet?text=${shareUrl}`;
    sendBlogInteractionActionEvent({
      interactionType: 'ArticleShareX',
      articleSlug: slug,
    });
    window.open(shareTwitterUrl, '', popupOptions);
  }

  function shareLinkedIn() {
    const shareLinkedInUrl = `https://www.linkedin.com/shareArticle?text=${shareUrl}`;
    sendBlogInteractionActionEvent({
      interactionType: 'ArticleShareLinkedIn',
      articleSlug: slug,
    });
    window.open(shareLinkedInUrl, '', popupOptions);
  }

  function shareFacebook() {
    const shareFacebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${shareUrl}`;
    sendBlogInteractionActionEvent({
      interactionType: 'ArticleShareFacebook',
      articleSlug: slug,
    });
    window.open(shareFacebookUrl, '', popupOptions);
  }

  async function copyLink() {
    sendBlogInteractionActionEvent({
      interactionType: 'ArticleShareLink',
      articleSlug: slug,
    });
    await copyToClipboard(shareUrl);
  }

  return (
    <div className={styles.shareIcons}>
      <button
        className={styles.shareButton}
        onClick={shareX}
        aria-label={t('Share.X')}
      >
        <XIcon />
      </button>
      <button
        className={styles.shareButton}
        onClick={shareLinkedIn}
        aria-label={t('Share.LinkedIn')}
      >
        <LinkedInIcon />
      </button>
      <button
        className={styles.shareButton}
        onClick={shareFacebook}
        aria-label={t('Share.Facebook')}
      >
        <FacebookIconV2 />
      </button>
      <button
        className={styles.shareButton}
        onClick={copyLink}
        aria-label={t('Share.Link')}
      >
        <LinkIcon />
      </button>
    </div>
  );
}
